import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: clamp(440px, 33vw, 700px);
`;

export const Search = styled.form`
  display: flex;
  flex-direction: row;
  width: 100%;
  position: relative;
  width: clamp(340px, 33vw, 700px);

  input {
    padding: 0.8rem 1rem;
    border: none;
    border-radius: 2rem 0 0 2rem;
    width: 100%;
    font-weight: 800;

    &::placeholder {
      opacity: 0.5;
      font-style: italic;
      font-weight: 400;
    }
  }

  .icon-search-button {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 0.7rem;
    color: var(--secondary_color);
    background-color: var(--secondary_color);
    border-radius: 0 2rem 2rem 0;
    border: none;

    .search-icon {
      font-size: 1.4rem;
      stroke-width: 1;
    }
  }
`;
